import React from "react";

const raleway = { fontFamily: "'Geist', sans-serif" };
const geistMono = { fontFamily: "'Geist Mono', monospace" };
const instrumentSerif = { fontFamily: "'Instrument Serif', Georgia, serif" };

const StillNeedHelp = () => {
  return (
    <>
      <style>{`
				@media (max-width: 767px) {
					.support-cta-section { padding: 40px 16px !important; }
					.support-cta-card { height: auto !important; padding: 48px 24px !important; }
					.support-cta-buttons { flex-wrap: wrap !important; gap: 8px !important; }
				}
			`}</style>

      <section
        className="support-cta-section"
        style={{
          width: "100%",
          boxSizing: "border-box",
          padding: "clamp(32px, 4vw, 60px) clamp(20px, 5.56vw, 80px) clamp(56px, 6.94vw, 100px)",
        }}
      >
        <div
          className="support-cta-card"
          style={{
            maxWidth: "1280px",
            margin: "0 auto",
            backgroundColor: "#132A22",
            borderRadius: "20px",
            padding: "clamp(56px, 7vw, 100px) clamp(24px, 5vw, 80px)",
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            textAlign: "center",
            gap: "clamp(20px, 2.4vw, 32px)",
          }}
        >
          <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
            <span
              style={{
                width: "8px",
                height: "8px",
                borderRadius: "50%",
                backgroundColor: "#86C7A8",
                display: "inline-block",
              }}
            />
            <span
              style={{
                ...geistMono,
                fontWeight: 500,
                fontSize: "12px",
                lineHeight: 1,
                letterSpacing: "0.1em",
                color: "#86C7A8",
                textTransform: "uppercase",
              }}
            >
              We're here
            </span>
          </div>

          <h2
            style={{
              ...instrumentSerif,
              fontWeight: 400,
              fontSize: "clamp(32px, 4.17vw, 60px)",
              lineHeight: 1.1,
              letterSpacing: "-0.01em",
              color: "#FFFFFF",
              margin: 0,
              maxWidth: "min(640px, 100%)",
            }}
          >
            Still need help?
          </h2>

          <p
            style={{
              ...raleway,
              fontWeight: 400,
              fontSize: "clamp(14px, 1.15vw, 16px)",
              lineHeight: 1.7,
              color: "rgba(255,255,255,0.72)",
              margin: 0,
              maxWidth: "min(440px, 100%)",
            }}
          >
            Our support team is ready to assist you.
          </p>

          <div
            className="support-cta-buttons"
            style={{
              display: "flex",
              gap: "12px",
              justifyContent: "center",
              marginTop: "8px",
            }}
          >
            <a
              href="#support-concern"
              style={{
                ...raleway,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: "48px",
                padding: "0 22px",
                backgroundColor: "#86C7A8",
                borderRadius: "10px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#132A22",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              Contact Support
            </a>
            <a
              href="https://wa.me/2349012345678"
              target="_blank"
              rel="noopener noreferrer"
              style={{
                ...raleway,
                display: "inline-flex",
                alignItems: "center",
                justifyContent: "center",
                height: "48px",
                padding: "0 22px",
                backgroundColor: "transparent",
                border: "1px solid rgba(255,255,255,0.3)",
                borderRadius: "10px",
                fontWeight: 500,
                fontSize: "14px",
                color: "#FFFFFF",
                textDecoration: "none",
                whiteSpace: "nowrap",
              }}
            >
              Chat on Whatsapp
            </a>
          </div>
        </div>
      </section>
    </>
  );
};

export default StillNeedHelp;
